import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { defineStyleConfig } from "@chakra-ui/react";

export const Button = defineStyleConfig({
  baseStyle: {
    rounded: "md",
    fontWeight: 700,
    _disabled: {
      pointerEvents: "none",
      cursor: "not-allowed",
    },
    transition: "all 0.2s",
    textWrap: "auto",
  },
  sizes: {
    md: {
      fontSize: "md",
      rounded: "md",
      py: 3,
      px: 5,
      lineHeight: "tall",
    },
    lg: {
      fontSize: "lg",
      rounded: "md",
      py: 3,
      px: 5,
      lineHeight: "tall",
    },
    xl: {
      fontSize: "lg",
      rounded: "full",
      py: 3,
      px: 5,
      lineHeight: "tall",
    },
  },
  variants: {
    solid: (props) => {
      const { main, light, text } = getColorScheme(props.colorScheme);
      return {
        bg: main,
        color: text,
        border: "1px solid transparent",
        _hover: {
          bg: light,
        },
        _disabled: {
          bg: light,
        },
      };
    },
    gradient: (props) => {
      const { main, light, text, tint } = getColorScheme(props.colorScheme);
      return {
        bgGradient: `linear(to-r, ${tint}, ${light})`,
        color: text,
        border: "1px solid transparent",
        _hover: {
          bgGradient: `linear(to-r, ${light}, ${light})`,
        },
        _disabled: {
          bgGradient: `linear(to-r, ${tint}, ${tint})`,
        },
      };
    },
    outline: (props) => {
      const { main, tint, light } = getColorScheme(props.colorScheme);
      return {
        bg: "transparent",
        color: "text",
        borderColor: main,
        _hover: {
          bg: tint,
        },
        _dark: {
          _hover: {
            bg: main,
          },
        },
      };
    },
    ghost: (props) => {
      const { main, tint, light } = getColorScheme(props.colorScheme);
      return {
        bg: "transparent",
        color: "text",
        _hover: {
          color: main,
          bg: "transparent",
        },
        _dark: {
          color: light,
          _hover: {
            color: tint,
            bg: "transparent",
          },
        },
      };
    },
    muted: (props) => {
      const { main, tint, light, dark, text } = getColorScheme(
        props.colorScheme,
      );
      return {
        bg: tint,
        color: "gray.800",
        border: "none",
        _hover: {
          bg: light,
          color: text,
        },
        _disabled: {
          bg: light,
        },
        _dark: {
          bg: dark,
          _hover: {
            bg: main,
            color: text,
          },
        },
      };
    },
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    colorScheme: "primary",
  },
});
